import { render, staticRenderFns } from "./CurricularMeshOtherTables.vue?vue&type=template&id=0aad3038&scoped=true"
import script from "./CurricularMeshOtherTables.vue?vue&type=script&lang=js"
export * from "./CurricularMeshOtherTables.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=0aad3038&prod&scoped=true&lang=css&external"
import style1 from "./CurricularMeshOtherTables.vue?vue&type=style&index=1&id=0aad3038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad3038",
  null
  
)

export default component.exports